import React, { Component, Fragment } from "react";
import { Row, Col, Input as AntInput } from "antd";
import {
  convertToListitem,
  formatRequstParams,
  orderQuestionnaire
} from "./utils";
import FormContainer from "../../../components/FormContainer";
import Input from "../../../components/Input";
import { pendingStates, pendingQaStates } from "../../../lib/util";
// import Form from "react-jsonschema-form";

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {},
      isLoading: false,
      approveBtnDisabled: true,
      rejectBtnDisabled: true
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormReject = this.handleFormReject.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { attributes, project, viewState, questionnaire } = nextProps;
    const { values } = this.state;

    if (Object.keys(values).length === 0 && questionnaire) {
      let defaultValues = {};
      for (let q in questionnaire) {
        defaultValues[q] = { value: "", isValid: false };
      }
      this.setState({ values: defaultValues });
    }

    if (attributes) {
      for (var a in attributes) {
        if (a === "compliance" || a === "surveyDesign" || a === "qaDetails") {
          attributes[a].forEach(
            item =>
              (values[item["propertyName"]] = {
                value: item["value"],
                isValid: true
              })
          );
        }
      }
    }

    const anyInvalidForReject = this.runRejectRules(values, project);
    const anyInvalidForApprove = this.runApproveRules(values, project);

    this.setState({
      rejectBtnDisabled: anyInvalidForReject,
      approveBtnDisabled: anyInvalidForApprove
    });

    if (viewState === "SURVEY_QA_SAVED") this.setState({ isLoading: false });
  }

  handleFormSubmit() {
    const { questionnaire } = this.props;
    const { values, isLoading } = this.state;
    if (isLoading) return;

    this.setState({ isLoading: true });

    const params = formatRequstParams(values, questionnaire);
    this.props.saveSurveyQa("approve", params);
    // Pop back to dashboard after submitting
    //this.props.history.push('/dashboard/lineitems');
  }

  handleFormReject() {
    const { questionnaire } = this.props;
    const { values, isLoading } = this.state;
    if (isLoading) return;

    this.setState({ isLoading: true });

    const params = formatRequstParams(values, questionnaire);
    this.props.saveSurveyQa("reject", params);
  }

  onInputChange(value, isValid, name) {
    const { values } = this.state;
    const { project } = this.props;

    values[name] = { value, isValid };

    const anyInvalidForReject = this.runRejectRules(values, project);
    const anyInvalidForApprove = this.runApproveRules(values, project);

    this.setState({
      rejectBtnDisabled: anyInvalidForReject,
      approveBtnDisabled: anyInvalidForApprove
    });
  }

  runRejectRules(values, project) {
    const lineItem = project.getLineItem();
    const state = lineItem[0].getState().toLowerCase();
    const qaState = lineItem[0].getQaState().toLowerCase();
    if (
      lineItem.length &&
      !pendingStates.includes(state) &&
      !pendingQaStates.includes(qaState)
    )
      return true;
    if (lineItem.length && !lineItem[0].getAssignedUser()) return true;
    Object.keys(values).some(name => {
      return (
        name.toLowerCase().includes("comments") && values[name].value === ""
      );
    });

    return Object.keys(values).some(name => {
      return values[name].value === "";
    });
  }

  runApproveRules(values, project) {
    const anyInvalid = Object.keys(values).some(name => {
      return (
        values[name].value === "" && !name.toLowerCase().includes("comments")
      );
    });

    if (anyInvalid) return true;

    const lineItem = project.getLineItem();
    const state = lineItem[0].getState().toLowerCase();
    const qaState = lineItem[0].getQaState().toLowerCase();
    if (
      lineItem.length &&
      !pendingStates.includes(state) &&
      !pendingQaStates.includes(qaState)
    )
      return true;
    return lineItem.length && !lineItem[0].getAssignedUser();
  }

  renderInfo() {
    const { project } = this.props;
    const lineItem = project.getLineItem();

    const { topic, clientExceptions } = project.getCategories();
    const categories = topic.map(c => c.description);
    const locale = lineItem[0].getLanguageCode() + "_" + lineItem[0].getCountryCode()
    const devices = project.getDeviceTypes().map((d, i) => (
      <span key={i} className="tag">
        {d}
      </span>
    ))

    const listItems = [
      { title: "Categories:", value: categories },
      {
        title: "Devices Targeted:",
        value: devices
      },
      {
        title: "Locale",
        value: locale
      },
      { title: "Length of Interview", value: lineItem[0].getLOI() }
    ];

    const convertedListItems = convertToListitem(listItems, "list-item");

    const exceptionList = () => {
      const exceptions = clientExceptions.map(r => ({
        title: r.description,
        value: r.allowed ? (
          <span className="tag green">allowed</span>
        ) : (
          <span className="tag red">not allowed</span>
        )
      }));
      const convertedExceptions = convertToListitem(exceptions, "list-item");
      return (
        <Fragment>
          <h4>Client Exceptions</h4>
          {convertedExceptions}
        </Fragment>
      );
    };
    const maybeExceptions =
      clientExceptions && clientExceptions.length > 0 && exceptionList();

    const { TextArea } = AntInput;
    return (
      <div className="info">
        {convertedListItems}
        {maybeExceptions}

        <div className="list-item-title">Survey Testing Notes</div>
        <TextArea rows={4} value={lineItem[0].getSurveyTestingNotes()} />
      </div>
    );
  }

  buildField(i, item, values, loi) {
    const { project } = this.props;
    const { clientExceptions } = project.getCategories();
    const key = item["name"];
    
    // Special cases
    /*
    `timeSpentQA` is a special case. It does not have `RejectionMessage`.
    `timeSpentQA` must not display `Required` in the UI. Thus set `required` to false.
    */
    if (item["ResponseType"] === "number" && "timeSpentQA" === key) {
      return (
        <Input
          required={true}
          key={i}
          name={key}
          value={values[key].value}
          type="number"
          placeholder="Enter a number"
          label={item["QuestionText"]}
          validator={item["EvaluationExpression"]}
          loi={loi}
          onChange={this.onInputChange}
          tooltip={item["TooltipMessage"]}
          message={item["RejectionMessage"]}
        />
      );
    }

    let byPassValidation = false

    /*
     If a project just has desktop targeting,
     and if the QA team has marked it as mobile incompatible,
     then that is not a rejection, and should show up as an acceptable outcome.
     */
    if ("mobileCompatibility" === key) {
      // By pass validation only when target devices hasn't got `mobile`.
      byPassValidation =
        !this.props.project.getDeviceTypes().includes("mobile")
    }
    if (key === "pii") {
      for (let r of clientExceptions) {
        if ((r.id === "PII_COLLECTION" || r.id === "WEBCAM") && r.allowed) {
          byPassValidation = true;
          break;
        }
      }
    }
    if (key === "appDownload") {
      for (let r of clientExceptions) {
        if (r.id === "APP_DOWNLOAD" && r.allowed) {
          byPassValidation = true;
          break;
        }
      }
    }
    // End special case
    switch (item["ResponseType"]) {
      case "boolean":
        return (
          <Input
            key={i}
            name={key}
            value={values[key].value.toString()}
            type="radio"
            label={item["QuestionText"]}
            validator={item["EvaluationExpression"]}
            onChange={this.onInputChange}
            tooltip={item["TooltipMessage"]}
            message={item["RejectionMessage"]}
            byPassValidation={byPassValidation}
          />
        );

      case "number":
        return (
          <Input
            key={i}
            name={key}
            value={values[key].value}
            type="number"
            placeholder="Enter a number"
            label={item["QuestionText"]}
            validator={item["EvaluationExpression"]}
            loi={loi}
            onChange={this.onInputChange}
            tooltip={item["TooltipMessage"]}
            message={item["RejectionMessage"]}
          />
        );
      case "string":
        return (
          <Input
            key={i}
            textArea
            name={key}
            value={values[key].value}
            placeholder="Comments and feedback for client"
            label={item["QuestionText"]}
            validator={item["EvaluationExpression"]}
            onChange={this.onInputChange}
            validForApprove={true}
          />
        );
      default:
        // Log warning
        console.warn(`Invalid ResponseType: ${item["ResponseType"]}`);
        return <React.Fragment />;
    }
  }

  render() {
    const { approveBtnDisabled, rejectBtnDisabled, values } = this.state;
    const { questionnaire, project } = this.props;
    const lineItem = project.getLineItem();
    const loi = lineItem[0].getLOI();
    const surveyTestURL = lineItem[0].getTestLink();
    const ordered = orderQuestionnaire(questionnaire);

    return (
      <FormContainer
        submitText="Approve"
        rejectText="Reject"
        isLoading={this.state.isLoading}
        onFormSubmit={this.handleFormSubmit}
        onFormReject={this.handleFormReject}
        approveBtnDisabled={approveBtnDisabled}
        rejectBtnDisabled={rejectBtnDisabled}
        surveyTestURL={surveyTestURL}
      >
        <div className="panel">
          <h1>Audit</h1>
          <Row type="flex">
            <Col span={16}>
              {Object.keys(values).length > 0 &&
                ordered.map((item, i) => this.buildField(i, item, values, loi))}
            </Col>
            <Col span={8}>{this.renderInfo()}</Col>
          </Row>
        </div>
      </FormContainer>
    );
  }
}

export default Footer;
